var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"name":"customCardFormView"}},[_c('v-card',{attrs:{"flat":"","rounded":"lg"}},[_c('HeaderCardNormal',{attrs:{"title":_vm.title}}),_c('div',{staticClass:"pt-5"}),_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }